import {SMALL} from './BreakPoints.js'
/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {

    isMobile : {
        default : false,
        [SMALL] : true
    },
    spacingInset_shorthand2 : {
        default : "none large",
        [SMALL] : "small small none small",
    },
    spacingInset_shorthand3 : {
        default : "large none",
        [SMALL] : "small none",
    },
    spacingInset_shorthand4 : {
        default : "large medium",
        [SMALL] : "medium small",
    },
    spacingInset_shorthand5 : {
        default : "small large none large",
        [SMALL] : "small medium none medium",
    },
    spacingInset_shorthand6 : {
        default : "medium none",
        [SMALL] : "none none",
    }
}


// WEBPACK FOOTER //
// ./src/commons/constants/ResponsiveProps.js